import { render, staticRenderFns } from "./editController.vue?vue&type=template&id=71f9b8fc&"
import script from "./editController.vue?vue&type=script&lang=ts&"
export * from "./editController.vue?vue&type=script&lang=ts&"
import style0 from "./editController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports